var map = {
	"./frame-designer/print/Uploader.jsx": 19914,
	"./frame-designer/qr/DigitalUploadPhoneModal.jsx": 41016,
	"./frame-designer/upload/ImageBrowser.jsx": 31301,
	"components/frame-designer/print/Uploader.jsx": 19914,
	"components/frame-designer/qr/DigitalUploadPhoneModal.jsx": 41016,
	"components/frame-designer/upload/ImageBrowser.jsx": 31301
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53892;